import dayjs from "dayjs";
import { computed, type Ref } from "vue";

export function useFormatDateTime(
  dateTime: Ref<string | number | Date | undefined>,
  format: string | undefined
) {
  const formatted = computed(() =>
    dateTime.value
      ? dayjs(dateTime.value).format(format || "YYYY-MM-DD HH:mm:ss")
      : ""
  );

  return { formatted };
}
